module.exports = __webpack_public_path__ + "static/media/not_connect_graphic.9433d388.png";